import { useQuery } from "@tanstack/react-query";
import * as tenantsApi from "@/services/tenantsApi";
import { setTenantCache } from "@/utils/customerLookup";

/**
 * Reactive hook that resolves tenant/customer IDs to display names.
 * Unlike the synchronous getCustomerNames(), this triggers a re-render
 * when tenant data loads, ensuring names appear instead of UUIDs.
 */
export function useCustomerNames(customerIds: string[]): string[] {
  const { data: tenantMap = {} } = useQuery({
    queryKey: ["tenants-map"],
    queryFn: async () => {
      const dtos = await tenantsApi.listTenants();
      const map: Record<string, string> = {};
      (dtos || []).forEach((dto: any) => {
        const id = dto.tenantId || dto.tenant_id || dto.id || "";
        const name = dto.tenantName || dto.tenant_name || dto.name || id;
        if (id) map[id] = name;
      });
      // Also update the synchronous cache for components that still use it
      setTenantCache(Object.entries(map).map(([id, name]) => ({ id, name })));
      return map;
    },
    staleTime: 5 * 60 * 1000,
  });

  return customerIds.map(id => tenantMap[id] || id);
}
